import React from 'react';
import { reduxForm, Field } from 'redux-form';
import classnames from 'classnames';
import isEmail from 'sane-email-validation';
import AnimatedButton from 'common/components/animated_button';
import { DEFAULT_REQUIRED_MESSAGE, EMAIL_INVALID_MESSAGE, TextInputField, EmailInputField,
  PasswordInputField, SelectField
} from 'common/components/form_fields';
import LanguageField from 'profile/containers/language_field';
import EmailNotValidated from 'account/containers/email_not_validated';
import ChangePassword from 'account/containers/change_password';

const InfoForm = (props) => (
  <form onSubmit={props.handleSubmit} noValidate>
    <fieldset>
      <h3 className="section-header">Login</h3>
      <div className="row">
        <div className="columns small-16 medium-12">
          <EmailNotValidated />
        </div>
        <div className="columns small-16 medium-8">
          <Field name="username" component={TextInputField} label="Username"
            disabled={!props.canEditUsername}
            formClasses={classnames({ "read-only": !props.canEditUsername })} />
          <Field name="email" component={EmailInputField} label="Email"
            verified={props.initialValues.is_email_validated} />
        </div>
      </div>
      <div className="row">
        <div className="columns small-16">
          <ChangePassword />
        </div>
      </div>
    </fieldset>

    <fieldset>
      <h3 className="section-header">Contact Info</h3>
      <div className="row">
        <div className="columns small-16 medium-8 large-6">
          <Field name="first_name" component={TextInputField} label="First name"
            disabled={!props.canEditName} />
        </div>
        <div className="columns small-16 medium-8 large-6">
          <Field name="last_name" component={TextInputField} label="Last name"
            disabled={!props.canEditName} />
        </div>
      </div>
      <div className="row">
        <div className="columns small-16 medium-8 large-6">
          <Field name="address_line_1" component={TextInputField} label="Address 1" />
        </div>
        <div className="columns small-16 medium-8 large-6">
          <Field name="address_line_2" component={TextInputField} label="Address 2" />
        </div>
      </div>
      <div className="row">
        <div className="columns small-16 medium-8 large-6">
          <Field name="city" component={TextInputField} label="City" />
        </div>
        <div className="columns small-16 medium-8 large-6">
          <Field name="state" component={TextInputField} label="State / Province" />
        </div>
      </div>
      <div className="row">
        <div className="columns small-16 medium-8 large-6">
          <Field name="postal_code" component={TextInputField} label="Zip / Postal code" />
        </div>
        <div className="columns small-16 medium-8 large-6">
          <Field name="country" component={SelectField} options={props.countries} label="Country" />
        </div>
      </div>
    </fieldset>

    <fieldset>
      <h3 className="section-header">Geography</h3>
      <div className="row">
        <div className="columns small-16 medium-8 large-6">
          <div className="form-group language language-primary">
            <label className="form-label" htmlFor="primary_lang">Primary Language</label>
            <Field name="primary_lang" component={LanguageField} formName="infoForm" />
          </div>
        </div>
        <div className="columns small-16 medium-8 large-6">
          <div className="form-group language language-secondary">
            <label className="form-label" htmlFor="additional_lang_1">Additional Language</label>
            <Field name="additional_lang_1" component={LanguageField} formName="infoForm" />
          </div>
        </div>
        <div className="columns small-16 medium-8 large-6 end">
          <Field
            name="user_timezone"
            component={SelectField}
            options={props.timezones}
            label="Timezone"
          />
        </div>
      </div>
    </fieldset>
    <fieldset className="form-controls">
      <AnimatedButton processing={props.submitting} type="submit" label="Save changes"
        baseBtnClass="btn-tertiary btn-block"  processingLabel="Saving..."
        errorMsg={props.error || props.submitFailed} successMsg="Changes Saved!"/>
    </fieldset>
  </form>
)

const validate = (values) => {
  const errors = {};
  const requiredFields = [
    "username", "first_name", "last_name", "city", "address_line_1", "postal_code", "state",
    "email"
  ];

  for (let fieldName of requiredFields) {
    if (!values[fieldName]) {
      errors[fieldName] = DEFAULT_REQUIRED_MESSAGE;
    }
  }

  /* validate email */
  if (!errors.email && !isEmail(values.email)) {
    errors.email = EMAIL_INVALID_MESSAGE;
  }

  return errors;
}

export default reduxForm({
  form: 'infoForm',
  validate
})(InfoForm);



// WEBPACK FOOTER //
// ./account/components/info_form.jsx